<template>
  <v-container class="pt-0 px-0">
    <v-subheader class="text-h5 px-0">Einstellungen</v-subheader>
    
    <v-select class="mt-3" :items="barcodepruefungItems" v-model="settings.barcodepruefung" label="Barcodeprüfung" hint="Genauigkeit des Barcodesscans" outlined item-text="text" item-value="val" color="white" item-color="grey lighten-5" persistent-hint></v-select>

    <v-select class="mt-3" :items="taschenlampeItems" v-model="settings.taschenlampe" label="Taschenlampe beim Scannen" hint="Standard beim Start des Kamera-Scanners" outlined item-text="text" item-value="val" color="white" item-color="grey lighten-5" persistent-hint></v-select>

    <v-select class="mt-3" :items="keyboardwedgesettings" v-model="settings.keyboardwedgescanner" label="Keyboard-Wedge Scanner" hint="Scanner mit Tastatursimulation (Spezielle Geräte)" outlined item-text="text" item-value="val" color="white" item-color="grey lighten-5" persistent-hint></v-select>

    <div class="d-flex mt-3">
        <v-text-field type="number" v-model="settings.avgTimeByChar" label="Durchschnittszeit per Buchstabe" placeholder="60" outlined color="white" persistent-hint suffix="ms"></v-text-field>
        <v-spacer></v-spacer>
        <v-text-field type="number" v-model="settings.timeBeforeScanTest" label="Zeit vor Scantest" placeholder="200" outlined color="white" persistent-hint suffix="ms"></v-text-field>
    </div>
    <v-switch class="mt-3" v-model="settings.sprachausgabe" label="Sprachausgabe bei Einsätzen" color="primary" hide-details></v-switch>
    <v-btn class="mx-0 mt-3" outlined block color="primary" :disabled="!sprachausgabeUnterstuetzt" @click="testSprachausgabe">
        <v-icon left>mdi-volume-high</v-icon>Sprachausgabe testen
    </v-btn>
    <div class="text-caption mt-1" v-if="sprachausgabeHinweis">{{ sprachausgabeHinweis }}</div>


    <v-subheader class="text-h6 px-0 mt-5">Einrichtung</v-subheader>
    <div class="text-caption mb-2">Richtet Sprachausgabe, NFC und Kamera auf diesem Gerät ein und fragt die nötigen Berechtigungen ab. Bitte alle Abfragen mit „Zulassen“ bestätigen, nicht mit „Nur dieses Mal“.</div>
    <v-btn class="mx-0" block color="primary" :loading="setupLaeuft" @click="geraetEinrichten">
        <v-icon left>mdi-cog-play</v-icon>Gerät einrichten
    </v-btn>
    <v-list dense class="py-0" v-if="setupErgebnis.length">
        <v-list-item v-for="e in setupErgebnis" :key="e.label" class="px-0">
            <v-list-item-icon class="mr-3">
                <v-icon :color="e.ok === null ? 'grey' : (e.ok ? 'green' : 'red')">{{ e.ok === null ? 'mdi-minus-circle' : (e.ok ? 'mdi-check-circle' : 'mdi-close-circle') }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ e.label }}</v-list-item-title>
                <v-list-item-subtitle class="text-wrap">{{ e.text }}</v-list-item-subtitle>
                <v-list-item-subtitle class="text-wrap mt-1" v-if="e.hilfe"><b>So geht's ({{ plattformName }}):</b> {{ e.hilfe }}</v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
    </v-list>

    <v-subheader class="text-h6 px-0 mt-5">Geräteunterstützung</v-subheader>
    <v-list dense class="py-0">
        <v-list-item v-for="check in geraeteChecks" :key="check.label" class="px-0">
            <v-list-item-icon class="mr-3">
                <v-icon :color="check.unterstuetzt ? 'green' : 'red'">{{ check.unterstuetzt ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ check.label }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>

    <v-textarea auto-grow label="Geräteerkennung" class="mt-3" :value="device" outlined readonly></v-textarea>

    <v-snackbar v-model="snackbar" :color="snackbar_color" timeout="5000" bottom class="snackbar text-center">{{ snackbar_text }}</v-snackbar>
  </v-container>
</template>

<script>
import emitter from '@/eventBus.js';

  export default {
    name: 'settings',
    data: () => ({
        settings:{
            barcodepruefung: 2,
            keyboardwedgescanner: "",
            taschenlampe: "last",
            avgTimeByChar: 60,
            timeBeforeScanTest: 200,
            sprachausgabe: true,
        },
        barcodepruefungItems:[
            {val: 1, text: "keine verbesserte Genauigkeit"},
            {val: 2, text: "gering verbesserte Genauigkeit"},
            {val: 3, text: "normale Genauigkeit"},
            {val: 4, text: "hohe Genauigkeit"},
        ],
        taschenlampeItems:[
            {val: "off", text: "Aus"},
            {val: "on", text: "Ein"},
            {val: "last", text: "Wie zuletzt eingestellt"},
        ],
        keyboardwedgesettings:[
            {val: "", text: "Kein Scanner mit Tastatursimulation"},
            {val: "CR", text: "Scanner mit Endezeichen CR"},
            {val: "LF", text: "Scanner mit Endezeichen LF"},
            {val: "CRLF", text: "Scanner mit Endezeichen CR/LF"},
            {val: "Tab", text: "Scanner mit Endezeichen Tab"},
        ],
        sprachausgabeHinweis: "",
        setupLaeuft: false,
        setupErgebnis: [],
        snackbar: false,
        device: false,
        snackbar_color: "success",
        snackbar_text: "Speichern erfolgreich",
        loaded: false,
        saveTimer: null,
    }),
    watch: {
        // Änderungen werden automatisch gespeichert (kurz verzögert, damit Tippen in Zahlenfeldern nicht jede Ziffer speichert)
        settings: {
            deep: true,
            handler(){
                if (!this.loaded) return;
                clearTimeout(this.saveTimer);
                this.saveTimer = setTimeout(this.save, 400);
            },
        },
    },
    mounted(){
        var s = localStorage.getItem("settings")
        if (s) this.settings = Object.assign({}, this.settings, JSON.parse(s));
        this.device = window.navigator.userAgent;
        // Erst nach dem Laden automatisch speichern, sonst würde das Laden selbst als Änderung gelten
        this.$nextTick(() => { this.loaded = true });
    },
    beforeDestroy(){
        // Noch ausstehende Änderung nicht verlieren, wenn die Seite sofort verlassen wird
        if (this.saveTimer) this.save();
    },
    methods: {
        // Stimmenliste wird von Browsern oft erst verzögert geladen (Chrome/Android), daher warten
        ladeStimmen(){
            return new Promise(resolve => {
                const synth = window.speechSynthesis;
                const v = synth.getVoices();
                if (v.length) return resolve(v);
                let fertig = false;
                const ende = () => {
                    if (fertig) return;
                    fertig = true;
                    synth.removeEventListener('voiceschanged', ende);
                    resolve(synth.getVoices());
                };
                synth.addEventListener('voiceschanged', ende);
                setTimeout(ende, 2000);
            });
        },
        // Einrichtung in einem Zug; der Tipp auf den Button liefert die nötige Nutzerinteraktion.
        // Reihenfolge: Sprache (sofort), NFC (braucht frische Interaktion), Kamera (Dialog, kann dauern)
        async geraetEinrichten(){
            this.setupLaeuft = true;
            this.setupErgebnis = [];
            // hilfe: Anleitung zum Setzen der Berechtigung für das verwendete Gerät, wenn etwas fehlt
            const add = (label, ok, text, hilfe) => this.setupErgebnis.push({label, ok, text, hilfe: ok ? "" : (hilfe || "")});

            // 1. Sprachausgabe
            if (!this.sprachausgabeUnterstuetzt) {
                add("Sprachausgabe", false, "Wird von diesem Browser nicht unterstützt.", this.hilfe.sprache);
            } else {
                await this.testSprachausgabe();
                const gefunden = this.sprachausgabeHinweis.startsWith("Deutsche Stimme");
                this.settings.sprachausgabe = gefunden ? true : this.settings.sprachausgabe;
                add("Sprachausgabe", gefunden, this.sprachausgabeHinweis, this.hilfe.sprache);
            }

            // 2. NFC
            if (!('NDEFReader' in window)) {
                add("NFC", null, "Nicht verfügbar (Gerät oder Browser unterstützt kein Web-NFC).", this.hilfe.nfcNichtVerfuegbar);
            } else {
                const ok = await new Promise(resolve => {
                    emitter.emit('nfc-init', { resolve });
                    setTimeout(() => resolve(false), 15000);
                });
                add("NFC", ok, ok ? "Bereit, Tags können gelesen werden." : "Nicht freigegeben. NFC am Gerät einschalten und die Abfrage mit „Zulassen“ bestätigen.", this.hilfe.nfc);
            }

            // 3. Kamera
            if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
                add("Kamera", false, "Wird von diesem Browser nicht unterstützt.", this.hilfe.kamera);
            } else {
                try {
                    const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
                    stream.getTracks().forEach(t => t.stop());
                    let hinweis = "Kamera freigegeben.";
                    let dauerhaft = true;
                    try {
                        const st = await navigator.permissions.query({ name: "camera" });
                        if (st.state !== "granted") {
                            dauerhaft = false;
                            hinweis += " Der Browser fragt aber weiter nach (Status: " + st.state + ").";
                        }
                    } catch (e) { /* permissions API nicht verfügbar */ }
                    // Bei nur vorübergehender Freigabe (oder iOS) trotzdem die Anleitung für dauerhaftes Zulassen zeigen
                    add("Kamera", dauerhaft, hinweis, this.hilfe.kameraDauerhaft);
                    if (!dauerhaft || this.plattform === "ios") this.setupErgebnis[this.setupErgebnis.length - 1].hilfe = this.hilfe.kameraDauerhaft;
                } catch (e) {
                    add("Kamera", false, e && e.name === "NotAllowedError"
                        ? "Zugriff verweigert. In den Browser-/Website-Einstellungen die Kamera für diese App auf „Zulassen“ stellen."
                        : "Kamera konnte nicht gestartet werden.", e && e.name === "NotAllowedError" ? this.hilfe.kamera : "Prüfen, ob eine andere App die Kamera verwendet, und die App neu starten.");
                }
            }

            this.save();
            this.setupLaeuft = false;
        },
        async testSprachausgabe(){
            // Der Tipp auf den Button schaltet die Sprachausgabe des Browsers für diese Sitzung frei
            this.$speak("Alarm. Sprachausgabe funktioniert.");
            const alle = await this.ladeStimmen();
            const stimmen = alle.filter(v => /^de/i.test(v.lang.replace('_', '-')));
            if (stimmen.length) {
                this.sprachausgabeHinweis = "Deutsche Stimme gefunden: " + stimmen[0].name + " (" + stimmen[0].lang + ")";
            } else if (alle.length) {
                const sprachen = [...new Set(alle.map(v => v.lang))].slice(0, 8).join(", ");
                this.sprachausgabeHinweis = "Keine deutsche Stimme gefunden. Vorhandene Sprachen: " + sprachen + ". Bitte in den Geräteeinstellungen eine deutsche Stimme installieren.";
            } else {
                this.sprachausgabeHinweis = "Der Browser meldet keine Sprachausgabe-Stimmen. Auf Android: Einstellungen > Allgemeine Verwaltung/System > Sprache > Text-in-Sprache-Ausgabe, Deutsch installieren; danach App neu starten. Läuft die App im Chrome, kann ein Test in Chrome selbst zeigen, ob es am Gerät liegt.";
            }
        },
        save(){
            clearTimeout(this.saveTimer);
            this.saveTimer = null;
            try{
                localStorage.setItem("settings",JSON.stringify(this.settings));
            }catch(e){
                // Nur im Fehlerfall melden, erfolgreiches Speichern läuft unauffällig im Hintergrund
                this.snackbar_color = "error";
                this.snackbar_text = "Speichern fehlerhaft";
                if (e.message) this.snackbar_text+= ': '+e.message
                this.snackbar = true;
            }
        },
    },
    computed: {
        plattform(){
            const ua = window.navigator.userAgent.toLowerCase();
            if (/iphone|ipad|ipod/.test(ua) || (ua.includes('macintosh') && navigator.maxTouchPoints > 1)) return "ios";
            if (/android/.test(ua)) return "android";
            return "desktop";
        },
        plattformName(){
            return { ios: "iPhone/iPad", android: "Android", desktop: "Computer" }[this.plattform];
        },
        // Anleitungen zum Setzen der Berechtigungen je nach Gerät
        hilfe(){
            const h = {
                android: {
                    kamera: "Handy-Einstellungen > Apps > Chrome (bzw. „Feuerwehrdatenbank-App“) > Berechtigungen > Kamera > „Zulassen“. Zusätzlich in Chrome: Schloss-/Einstellungssymbol in der Adressleiste > Berechtigungen > Kamera > „Zulassen“.",
                    kameraDauerhaft: "In der Kamera-Abfrage „Zulassen“ bzw. „Bei Verwendung der App“ wählen, nicht „Nur dieses Mal“. Bereits abgelehnt oder nur einmal erlaubt: Chrome-Menü ⋮ > Einstellungen > Website-Einstellungen > Kamera > diese Seite auf „Zulassen“ stellen.",
                    nfc: "1) NFC am Handy einschalten: Einstellungen > Verbundene Geräte (oder Verbindungen) > NFC. 2) Chrome-Menü ⋮ > Einstellungen > Website-Einstellungen > NFC-Geräte > diese Seite auf „Zulassen“. 3) Danach oben im Footer das NFC-Symbol antippen oder „Gerät einrichten“ erneut ausführen.",
                    nfcNichtVerfuegbar: "NFC funktioniert nur im Chrome-Browser auf Android-Geräten mit NFC-Chip. Bitte die App in Chrome öffnen oder installieren.",
                    sprache: "Einstellungen > System (oder Allgemeine Verwaltung) > Sprachen > Text-in-Sprache-Ausgabe > Bevorzugte Engine „Google“ > Zahnrad > Sprache „Deutsch“ wählen und Stimmendaten installieren. Außerdem Medienlautstärke aufdrehen.",
                },
                ios: {
                    kamera: "Einstellungen > Safari > Kamera > „Zulassen“ (oder „Fragen“). Bei der App vom Home-Bildschirm: Abfrage mit „Zulassen“ bestätigen.",
                    kameraDauerhaft: "iOS fragt bei Apps vom Home-Bildschirm nach jedem Start erneut nach der Kamera; das lässt sich nicht abstellen. Im Safari-Browser: Einstellungen > Safari > Kamera > „Zulassen“, oder in der Adressleiste „aA“ > Website-Einstellungen > Kamera > „Zulassen“.",
                    nfc: "",
                    nfcNichtVerfuegbar: "iPhone/iPad unterstützen NFC im Browser (Web-NFC) nicht. NFC-Tags lassen sich nur auf Android-Geräten mit Chrome lesen.",
                    sprache: "Einstellungen > Bedienungshilfen > Gesprochene Inhalte > Stimmen > Deutsch > eine Stimme laden. Der Stumm-Schalter muss aus sein und die Lautstärke aufgedreht.",
                },
                desktop: {
                    kamera: "Schloss-Symbol links in der Adressleiste > Website-Einstellungen > Kamera > „Zulassen“.",
                    kameraDauerhaft: "Schloss-Symbol links in der Adressleiste > Website-Einstellungen > Kamera > „Zulassen“. In der Abfrage „Bei jedem Besuch zulassen“ wählen.",
                    nfc: "NFC wird am Computer nicht unterstützt.",
                    nfcNichtVerfuegbar: "NFC wird am Computer nicht unterstützt, nur in Chrome auf Android.",
                    sprache: "In den Betriebssystem-Einstellungen eine deutsche Sprachausgabe-Stimme installieren (Windows: Einstellungen > Zeit und Sprache > Sprache > Deutsch > Sprachfeatures).",
                },
            };
            return h[this.plattform];
        },
        sprachausgabeUnterstuetzt(){
            return 'speechSynthesis' in window && 'SpeechSynthesisUtterance' in window;
        },
        geraeteChecks(){
            return [
                { label: "NFC", unterstuetzt: 'NDEFReader' in window },
                { label: "GPS", unterstuetzt: 'geolocation' in navigator },
                { label: "Barcodescanner (Kamera)", unterstuetzt: !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) },
            ]
        },
    }
  }
</script>
<style scoped>
    .snackbar{
        text-align: center;
    }
    .v-input__slot {
    align-items: right;
    justify-content:end
    }
</style>